module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/big/2-3e23325adbfd3b6cda416c5d59ba6e3a.webp";